import { i18n } from '../lang/i18n.js'
import utils from '../utils/index.js'


//设置查询参数data pn:接口名称 d:接口查询data
export const setSelectData = (state, {pn = '', d = {}} = {}) => {
  state[pn].data = {...state[pn].data, ...d}
  state[pn].lang = i18n.locale
  //设置loginId
  if (!state.userInfo) return
  let loginId = state.userInfo.account ? state.userInfo.account : JSON.parse(sessionStorage.userInfo).account
  state[pn].loginId = loginId
}
//全局loading控制
export const changeLoadingState = (state, {pn = '', s = false} = {}) => {
  state.loading[pn] = s
}

export const setChangePasswordVisible = (state, visible) => {
  state.passwordDialogVisible = visible
}

export const setAdvanceSearchAlert = (state,payload) => {
  state.showAdvanceSearchAlert = payload
}
export const setBrandActiveTabName = (state,activeTabName) => {
  state.brandActiveTabName = activeTabName
}
//设置用户信息
export const setUserInfo = (state,payload) => {
  state.userInfo.account = payload.account
  state.userInfo.password = payload.password
  state.userInfo.headImg = utils.baseUrl + 'usertx/' + payload.account + '.jpg'
  //缓存用户信息
  sessionStorage.userInfo = JSON.stringify(payload)
}

//设置菜单
export const setMenus = (state,menus) => {
    state.menus = menus
    sessionStorage.menus = JSON.stringify(menus)
}
export const setActiveMenuPath = (state,path) => {
    state.activeMenuPath = path
}
export const setShowHeadSearch = (state,show) => {
    state.showHeadSearch = show
}

//设置登录接口参数
export const setLoginInterfaceParams = (state,payload) => {
  state.loginInterfaceParams.loginId = payload.account
  state.loginInterfaceParams.data.password = payload.password
  state.loginInterfaceParams.lang = (i18n.locale == 'cn' ? 'zh-' + i18n.locale : i18n.locale)
}
//设置登陆状态
export const setLoginState = (state) => {
  sessionStorage.isLogin = 1
  state.isLogin = 1
}
export const setSignOutState = state => {
  sessionStorage.isLogin = 0
  state.isLogin = 0
}
//设置登陆窗口显示隐藏
export const setloginFade = (state, show) => {
  state.loginFade = show
}


//设置loginId
export const setLoginId = (state, payload) => {
  payload.lang = i18n.locale
  if (!state.userInfo) return
  let loginId = state.userInfo.account ? state.userInfo.account : JSON.parse(sessionStorage.userInfo).account
  payload.loginId = loginId
  console.log('setLoginId',state.userInfo,'language=',i18n.locale)
}

/**
 * boss
 */
//设置data数据
export const setData = (state, data) => {
  state.insertOrderParams.data = data
}

//关闭compare弹窗
export const closeCompare = (state) => {
  state.compareBtnShow = false
}

// boss搜索
export const setBossSearchName = (state, data) => {
  state.bossSearchName = data
}



// WEBPACK FOOTER //
// ./src/store/mutations.js